import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { NO_ERRORS_SCHEMA, NgModule, inject } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import {
  SedsBasicButtonModule,
  SedsCheckboxModule,
  SedsLoadersSpinnerModule,
} from "@serasa/shared/seds";

import { HeaderComponent } from "@serasa/shared/components/header/header.component";
import { PrivacyEffects } from "./state/effects/privacy.effect";
import { SharedModule } from "../../../shared/shared.module";
import { TermsOfUseComponent } from "./components/terms-of-use/terms-of-use.component";
import { TermsPageComponent } from "./pages/terms/terms.component";
import { privacyReducer } from "./state/reducers/privacy.reducer";
import { PrivacyGuard } from "./services/privacy.guard";

const routes: Routes = [
  {
    path: '',
    component: TermsPageComponent,
    canActivate: [() => inject(PrivacyGuard).canActivate()],
  },
];

@NgModule({
  declarations: [TermsOfUseComponent, TermsPageComponent],
  imports: [
    CommonModule,
    SedsBasicButtonModule,
    SedsCheckboxModule,
    SedsLoadersSpinnerModule,
    SharedModule,
    HeaderComponent,
    StoreModule.forFeature("privacy", privacyReducer),
    EffectsModule.forFeature([PrivacyEffects]),
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class PrivacyModule {}
